import { Box, TextNew } from '@jfs/ui-new'
import { styles } from './index'

export const GenerateFile = ({ label, onAction }: any) => {
  return (
    <Box flexDirection="row" alignItems="center" f={1}>
      <Box {...styles.buttonContainer} onPress={onAction} f={1}>
        <TextNew {...styles.buttonStyle}>{label}</TextNew>
      </Box>
    </Box>
  )
}
